/**
 * 雇用形態API クライアント
 */

import { authFetch, API_BASE_URL } from "./client";

export interface EmploymentTypeResponse {
    id: number;
    code: string;
    name: string;
    short_name: string | null;
    created_at: string | null;
    updated_at: string | null;
}

export interface EmploymentTypeListResponse {
    items: EmploymentTypeResponse[];
    total: number;
}

export interface EmploymentTypeCreateRequest {
    code: string;
    name: string;
    short_name?: string | null;
}

export interface EmploymentTypeUpdateRequest {
    code?: string;
    name?: string;
    short_name?: string | null;
}

export async function fetchEmploymentTypes(): Promise<EmploymentTypeListResponse> {
    const url = `${API_BASE_URL}/employment-types`;
    const response = await authFetch(url);
    if (!response.ok) throw new Error(`Failed to fetch employment types: ${response.status}`);
    return response.json();
}

export async function createEmploymentType(data: EmploymentTypeCreateRequest): Promise<EmploymentTypeResponse> {
    const url = `${API_BASE_URL}/employment-types`;
    const response = await authFetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`Failed to create employment type: ${response.status}`);
    return response.json();
}

export async function updateEmploymentType(id: number, data: EmploymentTypeUpdateRequest): Promise<EmploymentTypeResponse> {
    const url = `${API_BASE_URL}/employment-types/${id}`;
    const response = await authFetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`Failed to update employment type: ${response.status}`);
    return response.json();
}

/**
 * 雇用形態を削除（論理削除）
 */
export async function deleteEmploymentType(id: number): Promise<void> {
    const url = `${API_BASE_URL}/employment-types/${id}`;
    const response = await authFetch(url, {
        method: "DELETE",
    });
    if (!response.ok) {
        if (response.status === 404) {
            throw new Error("雇用形態が見つかりません");
        }
        throw new Error(`Failed to delete employment type: ${response.status}`);
    }
}
